export default function timesheetArrivalLabel(entry) {
    const parts = [];
    if (Number(entry.worked_minutes) > 0) parts.push(`${Number(entry.worked_minutes) / 60} ч.`);
    ['absence_code', 'travel_code', 'other_code'].forEach(field => {
        if (entry[field]) parts.push(entry[field]);
    });
    return parts.join(' · ') || 'Отметка';
}
